import { render, staticRenderFns } from "./commodityShow.vue?vue&type=template&id=4ee05ea1"
import script from "./commodityShow.vue?vue&type=script&lang=js"
export * from "./commodityShow.vue?vue&type=script&lang=js"
import style0 from "./commodityShow.vue?vue&type=style&index=0&id=4ee05ea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports